import { Action, Dispatch } from 'redux';
import { logToInternalAnalytics } from '../../api';
import { ROUTE_CHANGED, RouteChangedPayload } from './types';
import { SAVED_TRENDING_TOPIC } from '../content/types';
import { TopicViewModel } from '../../model/topic/types';
import { User } from 'oidc-client';
import {
  PAGE_VIEW_ACTIVITY_ID,
  SITE_ACCESS_ACTIVITY_ID,
} from '../../model/analytics/types';
import { usageLogIds } from '../../util/config';
interface AnalyticsAction extends Action<string> {
  payload: User | TopicViewModel | RouteChangedPayload;
}

declare global {
  interface Window { dataLayer: any[]; }
}

const MEMBERSITE_SOURCE_ID = 7;

export const usageLogMiddleware = (store: any) => (next: Dispatch) => (
  action: AnalyticsAction
) => {
  if (action.payload) {
    switch (action.type) {
      case 'redux-oidc/USER_FOUND': {
        const u = action.payload as User;
        const crmId =
          u?.profile?.[
            'http://schemas.ecri.org/sharepoint/2013/claims/crmguid'
          ];
        if (crmId && typeof window.ga !== 'undefined') {
          window.ga('set', 'userId', crmId);
        }
        if (crmId && window && window.dataLayer) {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({'user_id': crmId});
        }
        break;
      }
      case ROUTE_CHANGED: {
        const routeData = action.payload as RouteChangedPayload;
        const s = store.getState();
        const userId = s.auth?.user?.profile?.email ?? 'anonymous';
        const token = s.auth?.user?.access_token ?? '';
        if (userId !== 'anonymous' && token !== '') {
          logToInternalAnalytics(token, {
            activityId: PAGE_VIEW_ACTIVITY_ID,
            detail: `${routeData?.title} - ${routeData?.location?.href}`,
            siteId: routeData?.analyticsSiteId,
            sourceId: MEMBERSITE_SOURCE_ID,
            userId: userId,
          });
        }
        break;
      }
      case SAVED_TRENDING_TOPIC: {
        const savePayload = action.payload as TopicViewModel;
        const s = store.getState();
        const email = s.auth?.user?.profile?.email ?? '';
        const token = s.auth?.user?.access_token ?? '';
        if (email.trim() !== '' && token !== '') {
          logToInternalAnalytics(token, {
            activityId: SITE_ACCESS_ACTIVITY_ID,
            detail: `Add To My Topics - ${savePayload.description}`,
            siteId: usageLogIds.memberSite,
            sourceId: MEMBERSITE_SOURCE_ID,
            userId: email,
          });
        }
        break;
      }
    }
  }
  next(action);
};
